import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

import { AuthService } from '../api/auth/auth.service';

@Injectable({ providedIn: 'root' })
export class WhenAuthenticatedGuard  {

  constructor(private authenticationService: AuthService,
              private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Promise<boolean> {
    return this.authenticationService.checkAuthentication().then(
      () => {
        return true;
      },
      () => {
        this.router.navigate(['login']);
        return false;
      },
    );
  }
}
